<template>
    <field-wrapper class="field-RetireeProductVariants">
        <div
            v-for="pv in available"
            :key="pv.id"
            class="input-wrapper"
        >
            <input-radio
                v-model="checked"
                name="productVariant"
                :label="pv.id"
            >
                {{ pv.texts[$i18n.locale].name }}
            </input-radio>
        </div>
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputRadio from "@/components/inputs/InputRadio";
import { mapGetters, mapActions } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputRadio
    },
    computed: {
        checked: {
            get() {
                return this.selected ? this.selected.id : null;
            },
            set(newValue) {
                const pv = this.available.find(p => p.id === newValue)
                if (pv) {
                    this.prepareOrder({
                        municipalityId: pv.municipality.id,
                        productVariantId: pv.id
                    })
                }
            }
        },
        ...mapGetters({
            available: 'products/retireeticket/getAvailableProductVariants',
            selected: 'products/retireeticket/getSelectedProductVariant'
        })
    },
    methods: {
        ...mapActions({
            prepareOrder: 'products/retireeticket/prepareOrder'
        })
    }
};
</script>

<style scoped lang="scss">
.input-wrapper {
    margin-bottom: 0.75rem;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
